// @flow

import { h }             from "preact";
import { PureComponent,
         ScrollTop }     from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";
import { connect }       from "preact-redux";

import { create as createOrder,
         load   as loadCheckout,
         SUBMITTING } from "store-reducers/checkout";

import { load   as loadTerms,
         LOADED as TERMS_LOADED } from "store-reducers/terms";

import Button        from "components/Button";
import OverviewTable from "components/OverviewTable";
import Redirect      from "components/Redirect";
import Terms         from "components/Terms";

import { PUTTING as CART_PUTTING } from "reducers/cart";

@connect(
  state => ({
    cart         : state.cart,
    cartPutting  : state.cart.state === CART_PUTTING,
    checkoutData : state.checkout.data,
    items        : state.cart.items,
    payment      : state.checkout.payment,
    submitting   : state.checkout.state === SUBMITTING,
    termsLoaded  : state.terms.state === TERMS_LOADED,
    termsStatus  : state.terms.status,
  }),
  { createOrder, loadCheckout, loadTerms },
  ({ termsStatus, ...stateProps }, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    checkoutData: {
      ...stateProps.checkoutData,
      agreements: Object.keys(termsStatus)
                        .filter(k => termsStatus[k] === true)
                        .map(k => parseInt(k)),
    },
    grandTotal: stateProps.items.reduce((a, v) => a + v.product.price * v.qty, 0)
  }),
)
export default class Checkout extends PureComponent {
  checkoutDisabled = () =>
    this.props.cartPutting ||
    this.props.items.length === 0 ||
    this.props.submitting ||
    !this.state.acceptedTransaction;

  handleSubmit = (event: Event) => {
    event.preventDefault();

    if (!this.checkoutDisabled()) {
      this.props.createOrder({
        ...this.props.checkoutData,
        cart           : this.props.cart,
        paymentMethod  : "crossroads_benifybio",
        billingAddress : {
          countryId : this.context.t("LOCALE.ISO.3166-1"),
          ...this.props.checkoutData.billingAddress,
          useAsShippingAddress : true
        }
      });
    }
  }

  acceptTransaction = event => this.setState({ acceptedTransaction: event.target.checked });

  componentWillReceiveProps(nextProps) {
    if (nextProps.grandTotal !== this.props.grandTotal) {
      this.setState({
        acceptedTransaction: false
      });
    }
  }

  componentWillMount() {
    if (!this.props.termsLoaded) {
      this.props.loadTerms();
    }
  }

  render({ grandTotal, payment, submitting }: Props, { acceptedTransaction }: any, { t, formatPrice }: Context) {
    if (payment.paymentStatus === "COMPLETE" && payment.id) {
      return <Redirect to={{
        pathname : t("URL.SUCCESS"),
        search   : "?orderId=" + payment.id
      }} />;
    }

    return (
      <section
          class={classNames(
            this.props["class"],
            styles.block
          )}>

        <header class={styles.header}>
          <h1 class={classNames(
                styles.heading,
                "h2"
              )}>

            {t("CHECKOUT.HEADING")}
          </h1>
        </header>


        <form
            class={styles.form}
            onSubmit={this.handleSubmit}>

          <div class={styles.body}>
            <Terms
                class={styles.terms}
                grandTotal={grandTotal}
                acceptTransaction={this.acceptTransaction}
                acceptedTransaction={acceptedTransaction}
                disabled={submitting}
            />
          </div>

          <div class={styles.footer}>
            <Button
                modifiers="primary expand thick"
                type="submit"
                disabled={this.checkoutDisabled()}>

              {submitting ?
                t("CHECKOUT.SUBMITTING") :
                t("CHECKOUT.SUBMIT")}
            </Button>

          </div>
        </form>
      </section>
    );
  }
}
